import { motion } from "framer-motion";

const Sustainability = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white py-28">

      {/* 🌿 Imagen ambiental centrada */}
      <motion.img
        src="/lovable-uploads/fondo_soste.png"
        alt="Paisaje sostenible"
        className="
          absolute bottom-0 
          right-[5%] md:right-[12%]
          w-[620px] sm:w-[700px] md:w-[900px]
          opacity-95 select-none pointer-events-none
        "
        initial={{ opacity: 0, scale: 1.05, x: 60 }}
        animate={{ opacity: 1, scale: 1, x: 0 }}
        transition={{ duration: 2, ease: "easeOut" }}
      />

      {/* 🌱 Contenido principal */}
      <div className="relative z-10 container mx-auto px-6 flex flex-col md:flex-row items-start justify-between">
        <div className="max-w-xl text-left">

          {/* TÍTULO */}
          <motion.h2
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.2 }}
            className="text-5xl md:text-6xl font-extrabold mb-6 leading-tight"
          >
            <span style={{ color: "#3e8e27", fontWeight: 700 }}>
              Pequeñas acciones,
            </span>
            <br />
            <span style={{ color: "#0a5d1f", fontWeight: 800 }}>
              Gran impacto
            </span>
          </motion.h2>

          {/* SUBTÍTULO */}
          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.5, delay: 0.3 }}
            className="text-lg md:text-xl text-gray-700 max-w-md mb-10 leading-relaxed"
          >
            En SERGEN ayudamos a las PYMEs a lograr sostenibilidad sin aumentar
            sus costos. La eficiencia energética no solo cuida el planeta, sino
            que reduce el gasto eléctrico, impulsando un futuro rentable y responsable.
          </motion.p>

          {/* 🌎 CARDS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-lg">

            {/* CARD 1 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.6 }}
              whileHover={{ scale: 1.05 }}
              className="
                rounded-2xl p-8 text-left transition-all 
                border border-green-100
                shadow-[0_8px_24px_rgba(16,133,13,0.15)]

                /* 🟢 Transparencia MOBILE con efecto glass */
                bg-white/70 backdrop-blur-sm

                /* 🟢 VISTA DESKTOP: sólido y con gradiente */
                md:bg-gradient-to-b md:from-white md:to-green-50 md:backdrop-blur-none
                md:shadow-[0_8px_24px_rgba(16,133,13,0.15)]

                hover:shadow-[0_12px_32px_rgba(10,93,31,0.25)]
              "
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Reducción de
              </h3>

              <p
                className="text-5xl font-extrabold mb-3 drop-shadow-sm"
                style={{
                  color: "#0a5d1f",
                  textShadow: "0px 0px 10px rgba(12,92,33,0.15)",
                }}
              >
                -25%
              </p>

              <p className="text-gray-600 text-base">
                promedio en consumo energético
              </p>
            </motion.div>

            {/* CARD 2 */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2, delay: 0.8 }}
              whileHover={{ scale: 1.05 }}
              className="
                rounded-2xl p-8 text-left transition-all 
                border border-green-100
                shadow-[0_8px_24px_rgba(16,133,13,0.15)]

                /* 🟢 Transparencia MOBILE */
                bg-white/70 backdrop-blur-sm

                /* 🟢 DESKTOP sólido */
                md:bg-gradient-to-b md:from-white md:to-green-50 md:backdrop-blur-none
                md:shadow-[0_8px_24px_rgba(16,133,13,0.15)]

                hover:shadow-[0_12px_32px_rgba(10,93,31,0.25)]
              "
            >
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Reducción CO₂
              </h3>

              <p
                className="text-5xl font-extrabold mb-3 drop-shadow-sm"
                style={{
                  color: "#0a5d1f",
                  textShadow: "0px 0px 10px rgba(12,92,33,0.15)",
                }}
              >
                80 tn
              </p>

              <p className="text-gray-600 text-base">
                promedio anual por usuario
              </p>
            </motion.div>

          </div>
        </div>
      </div>

      {/* Gradiente inferior */}
      <div className="absolute bottom-0 left-0 w-full h-40 bg-gradient-to-t from-white to-transparent" />
    </section>
  );
};

export default Sustainability;